import { ActionTree, MutationTree } from 'vuex'
import { Notification, RootState } from '@/types'

export const namespaced = true

export interface State {
    persistentNotif?: Notification
    popupNotifs?: Notification[]
}

export const state: State = {
    persistentNotif: undefined,
    popupNotifs: undefined,
}

export const mutations: MutationTree<State> = {
    ADDPERSISTENT(state, notif) {
        state.persistentNotif = notif
    },
    DELETEPERSISTENT(state) {
        state.persistentNotif = undefined
    },
}

export const actions: ActionTree<State, RootState> = {
    addPersistent({ commit }, notification) {
        commit('ADDPERSISTENT', notification)
    },
    deletePersistent({ commit }) {
        commit('DELETEPERSISTENT')
    },
}
